import { inject } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentService } from 'app/payment/payment.service';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { lastValueFrom } from 'rxjs';

export const StripeResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  paymentService: PaymentService = inject(PaymentService)
): Promise<any> =>
  lastValueFrom(paymentService.getPublicKey()).then((stripePublicKey) => {
    return loadStripe(stripePublicKey).then((stripe) => stripe);
  });
